<template>
 <div :class="isTop?'header':'header nottop'">
       <div class="left_header">
                    <div @click="$router.push('/')" class="logo"><img src="https://oss.mifengbangzu.com/web/index/index_logo.png?x-oss-process=image/resize,p_30"></div>
            <!-- <div @click="$router.push('/')" class="logo"><img src="https://oss.mifengbangzu.com/web/index/logo.png?x-oss-process=image/resize,p_30"><div>运长安家</div></div> -->
        </div> 
        <el-menu router :default-active="$route.path"  class="right_header" background-color="#f5f7fa00"
          mode="horizontal" @select="handleSelect"  text-color="#fff" active-text-color="#ffd04b">
        <el-menu-item index="/">首页</el-menu-item>
        <el-menu-item index="/house">我要找房</el-menu-item>
        <el-submenu  index="3"  mode="horizontal">
            <template slot="title">公寓产品</template>
            <el-menu-item :class="isTop?'':'zi'" index="/huayi">华宜建筑装饰</el-menu-item>
            <el-menu-item :class="isTop?'':'zi'" index="/weige">维格家具装饰</el-menu-item>
            <el-menu-item :class="isTop?'':'zi'" index="/bangju">邦居公寓</el-menu-item>
        </el-submenu>
        <el-menu-item index="/xitong" >管理系统</el-menu-item>
        <el-menu-item index="/jiameng">合作共赢</el-menu-item>
        </el-menu>
 </div>
</template>
<script>
  export default {
  	name: "WebHeader",
    data() {
        return {
            activeIndex:"",isTop:true,
        };
    },
   created() {
            console.log(this.$route.path);
            this.activeIndex=this.$route.path;
            window.addEventListener("scroll",this.jt);
            let map={"/xitong":"/xitong_m",
            "/jiameng":"/jiameng_m",
            "/":"/index_m",
            "":"/index_m",
            "/index":"/index_m",
            "/jiameng":"/jiameng_m",
            "/huayi":"/huayi_m",
            "/weige":"/weige_m",
            "/bangju":"/bangju_m"};
             
            if(this.isMobile()){
               if( this.activeIndex ){
                 let a=map[this.activeIndex.toLowerCase()];
                   console.log(this.activeIndex.toLowerCase());
                 if(a){this.$router.push(a)}
               }
            }else{
                
            }

    },
   methods: {
            isMobile() {
                let flag = navigator.userAgent.match(
                /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
                );
                return flag;
            },

            handleSelect:function(e){
                //let ar={"1":"/index","2":"/house","3-1":"/huayi","3-2":"/weige","3-3":"/bangju","4":"/xitong","5":"/jiameng"};
            //    if(['/propertydetail'].includes(e)){
            //         this.$route.path='/house';
            //    }
              
                //this.$router.push({path:ar[e]});
            },
            jt:function(e){
               this.isTop=$(window).scrollTop()==0?true:false;
            },
    },
  }
</script>
<style lang="scss" scoped>

.zi{
    color: #097bed !important;
 }
.header{
    position:fixed; top: 0px;left:0px; width: 100%; z-index: 999; display: flex; box-shadow: 0px 1px 27px 0px rgba(11,3,6,0.51);
    &.nottop{ 
        background-color: #fff;
        /deep/ .el-menu-item, /deep/ .el-submenu__title {
                color: #000 !important;
        }
        /deep/ .el-menu-item{
             color: #000 !important;
        }


    }
    // opacity: 0.46;
    .left_header{
        width: 50%;
        height: 60px;
        display: flex;
        justify-content: end;
        .logo{
            // display: flex;
            // align-items: center;
            cursor: pointer;
            img{
               height: 30px;
            //    margin-right: 10px;
            }
            line-height: 60px;
            // line-height: 50px;
            margin-right: 200px;
            // color: #11934e;
            // font-size: 30px;
        }
    }
    .right_header{
        width: 50%;
        /deep/ .el-menu-item{
        font-size: 18px;
       } 
       /deep/  .el-submenu__title{
        font-size: 18px !important;
       }
       /deep/ .el-menu-item.is-active,/deep/ .el-submenu.is-active .el-submenu__title{
        color: #11934e !important;
        border-bottom-color:#11934e !important;
       }
       
    }
    /deep/ .el-menu.el-menu--horizontal{
        border-bottom:unset !important;
     }
}
</style>


// WEBPACK FOOTER //
// src/layouts/WebHeader/index.vue